import React, { useState, useEffect } from "react";
import ScheduleData from "./ScheduleData";

const EventSchedule = ({ height, name, link }) => {
  const [scheduleList, setScheduleList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSchedule = async () => {
      setLoading(true);
      try {
        const module = await import(`../assets/schedule_plan1.js`);
        setScheduleList(module.default);
      } catch (err) {
        console.error("Failed to load schedule:", err);
        setScheduleList([]);
      } finally {
        setLoading(false);
      }
    };
    loadSchedule();
  }, []);

  return (
    <div className="w-full px-4 md:px-12 py-8 flex flex-col items-center border-t">
      <p className="text-xl font-semibold text-one">Event Schedule</p>
      <div className="flex flex-wrap justify-center gap-4 my-6 bg-one/20 p-3 rounded-xl">
        <div className="flex items-center gap-2 px-4 py-3 rounded-full border text-sm transition-all bg-one text-white border-green-600">
          <div className="flex flex-row items-center gap-2">
            <h1 className="bg-white text-black p-1 rounded-lg font-semibold">Day 1</h1>
            <div>
              <p className="text-xl font-bold">7th August</p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">
        {loading ? (
          <p className="text-center text-slate-500">Loading schedule...</p>
        ) : Array.isArray(scheduleList) && scheduleList.length > 0 ? (
          <ScheduleData scheduleList={scheduleList} height={height} />
        ) : (
          <p className="text-center text-slate-500">No schedule available.</p>
        )}
      </div>
      {link && (
        <a href={link}>
          <button className="bg-one px-10 md:px-20 py-2 rounded-full mt-6 text-sm md:text-base">
            {name}
          </button>
        </a>
      )}
    </div>
  );
};

export default EventSchedule;
